import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'

import WhitelistTracking from './WhitelistTracking.vue'

registerVueComponentAndAngularBindings('whitelist:tracking', 'whitelistTracking', WhitelistTracking)